import React from "react";
import {
  workImgOne,
  workImgTwo,
  workImgThree,
  workImgFour,
  workImgFive,
  workImgSix,
  workImgSeven,
  workImgEight,
} from "../../assets";
import Title from "../home/Title";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <div>
      <Title title="Recent" subTitle="Projects" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <ProjectsCard
            title="MYB4Y Website"
            category="Website"
            image={workImgThree}
          />
          <ProjectsCard
            title="Landing Page"
            category="Ecommerce"
            image={workImgOne}
          />
        </div>
        <div className="px-6">
          <ProjectsCard
            title="Company Dashboard"
            category="Dashboard"
            image={workImgFour}
          />
          <ProjectsCard
            title="AI Driven product descriptions"
            category="API & Web design"
            image={workImgSix}
          />
          </div>
      </div>
    </div>
  );
};

export default Projects;
